import { BaseEntity } from '../base-entity';

export class FormEt004Filter extends BaseEntity {
    site_tratamento?: string;
    safra?: string;
    // tslint:disable-next-line: variable-name
    ca_tratamento_controle_analise?: number;
    // tslint:disable-next-line: variable-name
    data_tratamento_inicial?: Date;
    // tslint:disable-next-line: variable-name
    data_tratamento_final?: Date;
    // tslint:disable-next-line: variable-name
    tipo_produto?: string;
    // tslint:disable-next-line: variable-name
    hibrido?: string;
    // tslint:disable-next-line: variable-name
    is_incomplete: boolean;
    lote_fng?: string;
    responsavel_tratamento?: string;
}
